import BaseSetupService from '@/setup/BaseSetupService';
import BasePagedListFilterService from '@/services/BasePagedListFilterService';
import { Bus } from '@orion.ui/orion';
import { ref, watch } from 'vue';

type Props = SetupProps<typeof BasePagedListFilterSetupService.props>

export default abstract class BasePagedListFilterSetupService<P, F extends IPagedListParameters, T extends { id: number }> extends BaseSetupService<Props & P> {
	static readonly props? = {};

	protected abstract filterService: BasePagedListFilterService<F, T>;
	protected _aside?: OrionAside;
	readonly _submitButton = ref<OrionButton>();

	readonly optionsOrderAsc = [
		{
			label: 'Croissant',
			value: true,
		},
		{
			label: 'Décroissant',
			value: false,
		},
	];

	get filter () {
		return this.filterService.filter;
	}


	constructor (props?: Props & P, _aside?: OrionAside) {
		super(props);
		this._aside = _aside;

		if (this._aside) {
			this._aside.bus.on('enter-start', () => {
				this.filterService.storeLastFilter();
			});
		}
	}


	protected onMounted (): void {
		watch(this.filterService.filter, () => {
			this._submitButton?.value?._el()?.focus();
		});
	}

	cancelFilter () {
		this.filterService.cancel();
		this._aside?.close();
	}

	resetFilter () {
		this.filterService.reset();
	}

	async applyFilterAsync (modal?: OrionModal) {
		if (!!modal) {
			await this.filterService.applyAsync(true, modal);
			Bus.emit('OrderModalCandidateSetupService:close-filter');
		} else {
			await this.filterService.applyWithRouterAsync();
		}
		this._aside?.close();
	}
}
